export enum CategoryIds {
    LIFESTYLE = "LIFESTYLE",
    MOVEMENT = "MOVEMENT",
}
